import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ReviewTable from "./ReviewTable";
import Footer from "./Footer";
const ReviewList = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <ReviewTable />
      <Footer />
    </>
  );
};

export default ReviewList;
